import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import { getJobDetails, editJob, getJobCategories } from "../../slice/workerJobSlice";
import QuillEditor from "../text_editor";
import { toast } from "react-toastify";
import { getShiftJobDetails, editShiftJob } from "../../slice/workerShiftAddJobSlice";
import { getJobCategories } from "../../slice/workerJobSlice";

const stats = [
    { id: 1, code: 'AL', name: 'Alabama' },
    { id: 2, code: 'AK', name: 'Alaska' },
    { id: 3, code: 'AZ', name: 'Arizona' },
    { id: 4, code: 'AR', name: 'Arkansas' },
    { id: 5, code: 'CA', name: 'California' },
    { id: 6, code: 'CO', name: 'Colorado' },
    { id: 7, code: 'CT', name: 'Connecticut' },
    { id: 8, code: 'DE', name: 'Delaware' },
    { id: 9, code: 'FL', name: 'Florida' },
    { id: 10, code: 'GA', name: 'Georgia' },
    { id: 11, code: 'HI', name: 'Hawaii' },
    { id: 12, code: 'ID', name: 'Idaho' },
    { id: 13, code: 'IL', name: 'Illinois' },
    { id: 14, code: 'IN', name: 'Indiana' },
    { id: 15, code: 'IA', name: 'Iowa' },
    { id: 16, code: 'KS', name: 'Kansas' },
    { id: 17, code: 'KY', name: 'Kentucky' },
    { id: 18, code: 'LA', name: 'Louisiana' },
    { id: 19, code: 'ME', name: 'Maine' },
    { id: 20, code: 'MD', name: 'Maryland' },
    { id: 21, code: 'MA', name: 'Massachusetts' },
    { id: 22, code: 'MI', name: 'Michigan' },
    { id: 23, code: 'MN', name: 'Minnesota' },
    { id: 24, code: 'MS', name: 'Mississippi' },
    { id: 25, code: 'MO', name: 'Missouri' },
    { id: 26, code: 'MT', name: 'Montana' },
    { id: 27, code: 'NE', name: 'Nebraska' },
    { id: 28, code: 'NV', name: 'Nevada' },
    { id: 29, code: 'NH', name: 'New Hampshire' },
    { id: 30, code: 'NJ', name: 'New Jersey' },
    { id: 31, code: 'NM', name: 'New Mexico' },
    { id: 32, code: 'NY', name: 'New York' },
    { id: 33, code: 'NC', name: 'North Carolina' },
    { id: 34, code: 'ND', name: 'North Dakota' },
    { id: 35, code: 'OH', name: 'Ohio' },
    { id: 36, code: 'OK', name: 'Oklahoma' },
    { id: 37, code: 'OR', name: 'Oregon' },
    { id: 38, code: 'PA', name: 'Pennsylvania' },
    { id: 39, code: 'RI', name: 'Rhode Island' },
    { id: 40, code: 'SC', name: 'South Carolina' },
    { id: 41, code: 'SD', name: 'South Dakota' },
    { id: 42, code: 'TN', name: 'Tennessee' },
    { id: 43, code: 'TX', name: 'Texas' },
    { id: 44, code: 'UT', name: 'Utah' },
    { id: 45, code: 'VT', name: 'Vermont' },
    { id: 46, code: 'VA', name: 'Virginia' },
    { id: 47, code: 'WA', name: 'Washington' },
    { id: 48, code: 'WV', name: 'West Virginia' },
    { id: 49, code: 'WI', name: 'Wisconsin' },
    { id: 50, code: 'WY', name: 'Wyoming' },
];

const WorkerEditJobShift = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const token = localStorage.getItem("token");

    const { shiftJobDetails, loading, error } = useSelector(
        (state) => state.workerShiftJob
    );
    const { jobCategories } = useSelector(
        (state) => state.workerJob
    );

    const [form, setForm] = useState({
        title: "",
        categories: "",
        start_date: "",
        end_date: "",
        start_time: "",
        end_time: "",
        salary_min: "",
        salary_max: "",
        city: "",
        state: "",
        country: "US",
        role_type: "",
        description: "",
        currency: "",
        ratio: "",
        from_age: "",
        to_age: ""
    });

    useEffect(() => {
        dispatch(getShiftJobDetails({ id, token }));
        // dispatch(getJobCategories());
    }, [id, token, dispatch]);

    const shift = shiftJobDetails.shift_request;

    useEffect(() => {
        if (!shift) return;

        const [from_age, to_age] =
            shift.classroom_age_group?.split("-") || ["", ""];

        const roleType = String(shift.role_type); // ✅ normalize

        setForm({
            title: shift.title || "",
            categories_id: shift.categories_id ?? "",
            start_date: shift.start_date || "",
            end_date: shift.end_date || "",
            start_time: shift.start_time?.slice(0, 5) || "",
            end_time: shift.end_time?.slice(0, 5) || "",
            salary_min: shift.salary_min || "",
            salary_max: shift.salary_max || "",
            city: shift.city || "",
            state: shift.state || "",
            country: shift.country || "US",
            role_type: roleType,
            description: shift.description || "",
            ratio: shift.ratio || "",
            from_age,
            to_age,
        });

        dispatch(getJobCategories(roleType)); // ✅ works now
    }, [shift, dispatch]);



    console.log("getshift", shift);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleChange1 = (e) => {
        const role = e.target.value;
        const value = e.target.dataset.value;

        // ✅ CALL API ON RADIO CHANGE
        dispatch(getJobCategories(role));

        setForm((prev) => ({
            ...prev,
            role_type: role,
            title: "Job For " + value,
            categories_id: "", // reset category when role changes
        }));
    };


    const checkValidation = () => {
        if (!form.title) return toast.error("Please enter title"), false;
        if (!form.city) return toast.error("Please enter city"), false;
        if (!form.state) return toast.error("Please enter state"), false;
        if (!form.start_date) return toast.error("Please enter start date"), false;
        if (!form.start_time) return toast.error("Please enter start time"), false;
        if (!form.end_time) return toast.error("Please enter end time"), false;
        if (!form.salary_min) return toast.error("Please enter minimum salay"), false;
        if (!form.salary_max) return toast.error("Please enter maximum salay"), false;
        // if (!form.classroom_age_group) return toast.error("Please enter Age group"), false;
        if (!form.role_type) return toast.error("Please select role type"), false;
        if (!form.ratio) return toast.error("Please select ratio"), false;
        if (!form.description) return toast.error("Please enter description"), false;
        return true;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!checkValidation()) return;

        const payload = {
            title: form.title,
            categories_id: form.categories_id,
            start_date: form.start_date,
            end_date: form.end_date,
            start_time: form.start_time,
            end_time: form.end_time,
            salary_min: form.salary_min,
            salary_max: form.salary_max,
            city: form.city,
            state: form.state,
            country: form.country,
            role_type: form.role_type,
            currency: form.currency,
            ratio: form.ratio,
            description: form.description,
            classroom_age_group: `${form.from_age}-${form.to_age}`,
        };

        dispatch(editShiftJob({ id, token, payload }))
            .unwrap()
            .then(() => {
                toast.success("Shift Job updated successfully!");
                navigate("/panel/shift-jobs");
            })
            .catch(() => {
                toast.error("Failed to update shift job");
            });
    };

    return (
        <>
            <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
                <div className="ps-2 ps-lg-4">

                    <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">Edit Shift Request</h4>
                    <div className="form-section mt-3">
                        <form onSubmit={handleSubmit}>
                            <div className="row g-3">
                                <div className="col-sm-12 d-flex font-size-16">
                                    <label className="form-label text-primary mb-2 font-weight-semibold required">
                                        I would like to create shift request for:
                                    </label>

                                    <div className="d-flex ms-2">

                                        <div className="form-check me-3">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="role_type"
                                                id="role_teacher"
                                                value="5"
                                                data-value="Teachers & Assistants"
                                                checked={form.role_type === "5"}
                                                onChange={handleChange1}
                                            />
                                            <label className="form-check-label" htmlFor="role_teacher">
                                                Teachers & Assistants
                                            </label>
                                        </div>

                                        <div className="form-check me-3">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="role_type"
                                                id="role_support"
                                                value="6"
                                                checked={form.role_type === "6"}
                                                onChange={handleChange1}
                                                data-value="Support Staffing Roles"
                                            />
                                            <label className="form-check-label" htmlFor="role_support">
                                                Support Staffing Roles
                                            </label>
                                        </div>

                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <label className="form-label text-primary mb-1 font-weight-semibold required">Title</label>
                                    <input
                                        type="text"
                                        name="title"
                                        className="form-control"
                                        value={form.title}
                                        onChange={handleChange}
                                    />
                                </div>
                                {form.role_type == "5" && (
                                    <div className="col-sm-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Select Category</label>
                                        <select
                                            className="form-select"
                                            name="categories_id"
                                            value={form.categories_id ?? ""}
                                            onChange={handleChange}
                                        >
                                            <option value="">-- Select --</option>
                                            {jobCategories?.map((cat) => (
                                                <option key={cat.id} value={cat.id}>
                                                    {cat.name}
                                                </option>
                                            ))}
                                        </select>

                                    </div>
                                )}
                                {form.role_type == "6" && (
                                    <div className="col-sm-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Select Category</label>
                                        <select
                                            className="form-select"
                                            name="categories_id"
                                            value={form.categories_id ?? ""}
                                            onChange={handleChange}
                                        >
                                            <option value="">-- Select --</option>
                                            {jobCategories?.map((cat) => (
                                                <option key={cat.id} value={cat.id}>
                                                    {cat.name}
                                                </option>
                                            ))}
                                        </select>

                                    </div>
                                )}
                                <>
                                    <label className="form-label text-primary mb-1 font-weight-semibold">
                                        Please provide job location
                                    </label>
                                    <div className="col-sm-6 d-flex gap-3">
                                        <div className="col">
                                            <label className="form-label text-primary mb-1 font-weight-semibold required">
                                                City
                                            </label>
                                            <input
                                                type="text"
                                                name="city"
                                                className="form-control"
                                                value={form.city}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        <div className="col">
                                            <label className="form-label text-primary mb-1 font-weight-semibold required">
                                                State
                                            </label>
                                            <select class="form-select" name="state" required="" onChange={handleChange}>
                                                <option>Select state</option>
                                                {stats.map(cat => (
                                                    <option selected={form.state === cat.code} key={cat.id} value={cat.code}>{cat.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </>
                                <>
                                    <label className="form-label text-primary mb-1 font-weight-semibold">
                                        Please provide shift dates & time
                                    </label>
                                    <div className="col-sm-6 d-flex gap-3">
                                        <div className="col">
                                            <label className="form-label text-primary mb-1 font-weight-semibold required">
                                                From Date
                                            </label>
                                            <input type="date" name="start_date" className="form-control" value={form.start_date} onChange={handleChange} />
                                        </div>

                                        <div className="col">
                                            <label className="form-label text-primary mb-1 font-weight-semibold required">
                                                To Date
                                            </label>
                                            <input type="date" name="end_date" className="form-control" value={form.end_date} onChange={handleChange} />
                                        </div>
                                    </div>
                                </>

                                <div className="col-sm-6 d-flex gap-3">

                                    <div className="col">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">
                                            Start Time
                                        </label>
                                        <input type="time" name="start_time" className="form-control" value={form.start_time} onChange={handleChange} />
                                    </div>

                                    <div className="col">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">
                                            End Time
                                        </label>
                                        <input type="time" name="end_time" className="form-control" value={form.end_time} onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-sm-6 d-flex gap-3">
                                    <div className="col">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Salary range will be</label>
                                        <input
                                            type="text"
                                            name="salary_min"
                                            className="form-control"
                                            placeholder="e.g 25000"
                                            value={form.salary_min}
                                            onChange={handleChange}

                                        />
                                    </div>
                                    <div className="col">
                                        <label className="form-label text-primary mb-1 font-weight-semibold">&nbsp;</label>
                                        <input
                                            type="text"
                                            name="salary_max"
                                            className="form-control"
                                            placeholder="e.g 45000"
                                            value={form.salary_max}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <div className="col-sm-6 d-flex gap-3">
                                    <div className="col">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Currency</label>
                                        <select className="form-select" name="currency" onChange={handleChange} value={form.currency}>
                                            <option value="USD">USD</option>
                                            <option value="EUR">EUR</option>
                                            <option value="GBP">GBP</option>
                                        </select>
                                    </div>
                                    <div className="col">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Ratio</label>
                                        <select className="form-select" name="ratio" value={form.ratio} onChange={handleChange} >
                                            <option value="">Select Job Salary Ratio</option>
                                            <option value="yearly">Per Year</option>
                                            <option value="monthly">Per Month</option>
                                            <option value="weekly">Per Week</option>
                                        </select>
                                    </div>
                                </div>

                                <label className="form-label text-primary mb-1 font-weight-semibold">
                                    Worker required between age group
                                </label>
                                <div className="col-sm-6 d-flex gap-3">
                                    <div className="col">
                                        {/* <label className="form-label text-primary mb-1 font-weight-semibold required">
                                            From Age
                                        </label> */}
                                        <input
                                            type="number"
                                            name="from_age"
                                            className="form-control"
                                            placeholder="from"
                                            value={form.from_age}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col">
                                        {/* <label className="form-label text-primary mb-1 font-weight-semibold required">
                                            To Age
                                        </label> */}
                                        <input
                                            type="number"
                                            name="to_age"
                                            className="form-control"
                                            placeholder="to"
                                            value={form.to_age}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div >
                                    <label className="form-label text-primary mb-1 font-weight-semibold required">Provide some Details of request</label>
                                    <QuillEditor
                                        value={form.description}
                                        onChange={(val) => setForm(prev => ({ ...prev, description: val }))}
                                    />
                                </div>
                                <div className="col-12 mt-4">
                                    <button
                                        type="submit"
                                        className="btn btn-primary me-2"
                                        style={{ background: "#014e4e" }}
                                        disabled={loading}
                                    >
                                        {loading ? "Updating..." : "Update Shift Request"}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        style={{ background: "#014e4e" }}
                                        onClick={() => navigate(-1)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
};

export default WorkerEditJobShift;